// ============================================================================
// hvsin User Center Contracts
//
// 本包仅包含类型定义和常量，不含实现。
// user-center-client-mod 以及第三方业务 Mod 通过此包获取类型信息，
// 通过 hvsin 依赖注入机制获取实际 Service 实例。
// ============================================================================
// ----------------------------------------------------------------------------
// 3. 接口标签常量
// ----------------------------------------------------------------------------
/** IUserCenterSlotsService 接口标签常量（用于依赖注入） */
export const USER_CENTER_SLOTS_INTERFACE_TAG = 'IUserCenterSlotsService';
// ----------------------------------------------------------------------------
// 4. 内置 Section 标识
// ----------------------------------------------------------------------------
/** 内置个人信息 Section 的 id */
export const PROFILE_SECTION_ID = 'profile';
/** 用户中心路由路径 */
export const USER_CENTER_PATH = '/user-center';
//# sourceMappingURL=index.js.map